import React from 'react';
import styles from './IconWrapper.module.sass';

const IconWrapper = ({
    children
}: any) => {
    return <div className={styles['iconwrapper']}>
        { children }
    </div>;
}

export default IconWrapper;